import React from 'react';
import { Box, BoxProps } from '@chakra-ui/react';

export const Paper: React.VFC<BoxProps> = (props) => {
  return (
    <Box borderWidth="1px" borderRadius="lg" bgColor="white" {...props}></Box>
  );
};
